import Box from '@mui/material/Box';
import { alpha, useTheme } from '@mui/material/styles';
import { CenterPositionedCol } from 'components/flex-containers';
import { LightGrayLabel } from 'components/labels';
import { Text } from 'components/Text';
import { getTrans } from 'modules/i18n';

interface CommentViewProps {
  comment: string;
  pt?: number;
  title?: string;
}

export const CommentView = ({
  comment,
  pt = 2,
  title = getTrans('shiftDetailsPage.comment.title')
}: CommentViewProps) => {
  const theme = useTheme();

  return (
    <CenterPositionedCol sx={{ pt }}>
      <Text variant="h6" sx={{ whiteSpace: 'nowrap' }}>
        {title}
      </Text>
      <Box
        sx={{
          mt: 2,
          p: 2,
          width: '100%',
          border: '1px solid',
          borderColor: alpha(theme.palette.grey[500], 0.2),
          borderRadius: 1
        }}
      >
        <LightGrayLabel data-sentry-mask variant="body2">
          {comment}
        </LightGrayLabel>
      </Box>
    </CenterPositionedCol>
  );
};
